import { render, staticRenderFns } from "./TopBack.vue?vue&type=template&id=20646246&scoped=true&"
import script from "./TopBack.vue?vue&type=script&lang=js&"
export * from "./TopBack.vue?vue&type=script&lang=js&"
import style0 from "./TopBack.vue?vue&type=style&index=0&id=20646246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20646246",
  null
  
)

export default component.exports